export default __webpack_public_path__ + "static/media/omint.0ab59cdf.png";